import Backbone from 'backbone';
import ko from 'knockout';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';
import tmpl from '@bingads-webui-campaign-legacy/auto-targets/template/create/custom-label.pug';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');
const webpageCondition = window.globalLegacySchema.get('WebpageCondition');

export default class View extends Backbone.View {
  initialize(options) {
    this.options = options;
    this.viewModel = {};
    koSchema.properties(this.viewModel, webpageCondition, ['ArgumentOperand', 'Operand', 'Operator']);
    this.viewModel.Operand('CustomLabel'); //eslint-disable-line
    this.viewModel.Operator('Equals'); //eslint-disable-line
  }
  get events() {
    return {
      'click .arrow-button': 'selectTarget',
    };
  }
  render() {
    this.$el.html(tmpl({
      i18n,
    }));
    ko.applyBindings(this.viewModel, this.el);
    return this;
  }
  reset() {
    this.viewModel.ArgumentOperand(''); //eslint-disable-line
    this.viewModel.ArgumentOperand.errors([]);
    this.viewModel.errors([]);
  }
  show() {
    this.$el.show();
    return this;
  }
  hide() {
    this.$el.hide();
    return this;
  }
  selectTarget() {
    if (!this.viewModel.validate()) {
      return;
    }
    const condition = {
      DisplayOperand: i18n.get('DSA_AutoTargets_Specific_Target_Operand_Custom_Label'),
      DisplayOperator: i18n.get('DSA_AutoTargets_Specific_Target_Equals'),
    };

    koSchema.properties(condition, webpageCondition, ['ArgumentOperand', 'Operand', 'Operator'], this.viewModel.toObject());
    this.trigger('selectTarget', {
      conditions: [condition],
      type: 'specificpage',
      shouldCheckArgumentOperandFormat: this.options.shouldCheckArgumentOperandFormat,
    });
  }
}
